import { useState } from 'react';

import { Mic, MicOff, VolumeUp } from '@mui/icons-material';
import { Tooltip, IconButton, Slider as MuiSlider } from '@mui/joy';
import { styled } from '@mui/joy/styles';

// Define a custom Slider component with all blue styling
const Slider = styled(MuiSlider)(() => ({
  '& .MuiSlider-track': {
    backgroundColor: '#0a6bcb' // Blue color for the track
  },
  '& .MuiSlider-thumb': {
    backgroundColor: 'white', // Thumb color (white)
    border: 'none', // Remove any border (if there's any)
    '&:focus, &:active, &:hover': {
      boxShadow: 'none', // Remove any yellow ring (focus/active/hover)
      outline: 'none', // Remove the outline (focus ring)
      borderColor: 'transparent' // Ensure there's no border color when active
    },
    '&:focus-visible': {
      outline: 'none', // Specifically target focus-visible for accessibility
      boxShadow: 'none' // Remove any box-shadow when focused (on keyboard focus)
    }
  },
  '& .MuiSlider-rail': {
    backgroundColor: '#e0e0e0', // Blue color for the rail
    opacity: 1 // Ensure the rail is fully visible and blue
  }
}));

const VolumeControl: React.FC = () => {
    const [micOn, setMicOn] = useState(false);
    const [volume, setVolume] = useState(50);

    const handleMicToggle = () => setMicOn((prev) => !prev);
    const handleVolumeChange = (event: Event, newValue: number | number[]) => {
        setVolume(newValue as number);
    };

    return (
        <div className="flex items-center gap-3">
            <Tooltip title={micOn ? 'Mic On' : 'Mic Off'}>
                <IconButton color={micOn ? 'primary' : 'neutral'} onClick={handleMicToggle}>
                    {micOn ? <Mic /> : <MicOff />}
                </IconButton>
            </Tooltip>
            <VolumeUp />
            <Slider
                aria-labelledby="volume-slider"
                max={100}
                min={0}
                onChange={handleVolumeChange}
                sx={{
                    'Slider-trackBackground': '#0a6bcb', // teal
                    'Slider-thumbBackground': '#0a6bcb', // darker teal
                    'Slider-railBackground': '#0a6bcb', // light teal
                    color: undefined,
                    width: 250 // unset Joy's built-in color so it doesn't override
                  }}
            
                value={volume}
            />
        </div>
    );
};

export default VolumeControl;
